import { isActivePlus } from './Products';
import { mmddyyyy } from './Dates';
import { activePlusAccountUrl } from './Externals';
import React, { Fragment } from 'react';
import { EMPTY_CELL_DASH, findMatchingAdviceGridAccount } from './TableUtils';
import {
  getCustomerWebView,
  getUberId
} from '../state/customer/CustomerSelectors';
import { formatPercentAmount } from 'services/Formats';
import { adjustPercent } from 'services/Calculation';
import { connect } from 'react-redux';

const PRRRenderer = ({ valueFormatted, data, node, isCWV, uberId }) => {
  const { group, field, key } = node;
  const account = findMatchingAdviceGridAccount(key);
  const {
    performanceInceptionDate,
    productType,
    accountId,
    isPosition,
    performance
  } = data ? data : account ? account : {};

  if (isPosition) {
    return '';
  }

  if (key && account && field === 'groupId') {
    valueFormatted = performance
      ? formatPercentAmount(adjustPercent(performance))
      : EMPTY_CELL_DASH;
  }
  const prrClassName =
    group && field !== 'primaryOwner' && field !== 'groupId'
      ? 'prr-cell-group'
      : 'prr-cell';
  const isApp = productType && isActivePlus(productType);
  const showDash = !isApp || (isApp && valueFormatted !== EMPTY_CELL_DASH);
  const displayDate =
    performanceInceptionDate === EMPTY_CELL_DASH
      ? performanceInceptionDate
      : mmddyyyy(performanceInceptionDate, '/');

  return (
    <div className={prrClassName}>
      {showDash && valueFormatted}
      {performanceInceptionDate &&
        (valueFormatted === EMPTY_CELL_DASH ? (
          isApp ? (
            <a
              href={activePlusAccountUrl(accountId, isCWV, uberId)}
              className="app-prr-link"
            >
              View Return
            </a>
          ) : (
            EMPTY_CELL_DASH
          )
        ) : (
          <Fragment>
            <br />
            <span>{displayDate}</span>
          </Fragment>
        ))}
    </div>
  );
};

const mapStateToProps = (state) => ({
  uberId: getUberId(state),
  isCWV: getCustomerWebView(state)
});

export default connect(mapStateToProps)(PRRRenderer);
